import { render } from "./AuthorInputPage.vue?vue&type=template&id=47665ecb&scoped=true&ts=true"
import script from "./AuthorInputPage.vue?vue&type=script&lang=ts"
export * from "./AuthorInputPage.vue?vue&type=script&lang=ts"

import "./AuthorInputPage.vue?vue&type=style&index=0&id=47665ecb&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47665ecb"]])

export default __exports__